/*
 * TeamNotes Messages
 *
 * This contains all the text for the TeamNotes container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.TeamNotes';

export default defineMessages({
  notes: {
    id: `${scope}.notes`,
    defaultMessage: 'Notes',
  },
  noteSuccess: {
    id: `${scope}.noteSuccess`,
    defaultMessage: 'Note is created successfully',
  },
  noteUpdate: {
    id: `${scope}.noteUpdate`,
    defaultMessage: 'Note is updated successfully',
  },
  noteDeleted: {
    id: `${scope}.noteDeleted`,
    defaultMessage: 'Note is deleted successfully',
  },
  dDay: {
    id: `${scope}.dDay`,
    defaultMessage: 'D day notes',
  },
  addNote: {
    id: `${scope}.addNote`,
    defaultMessage: 'Add a note...',
  },
  firstNote: {
    id: `${scope}.firstNote`,
    defaultMessage: 'Be first to add note',
  },
  send: {
    id: `${scope}.send`,
    defaultMessage: 'Send',
  },
  editNote: {
    id: `${scope}.`,
    defaultMessage: 'Edit note',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  update: {
    id: `${scope}.update`,
    defaultMessage: 'Update',
  },
  deletConf: {
    id: `${scope}.deletConf`,
    defaultMessage: 'Delete the note?',
  },
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'Delete',
  },
  loadMore: {
    id: `${scope}.loadMore`,
    defaultMessage: 'Load old notes',
  },
});
